module.exports = __webpack_public_path__ + "img/15.932de5b3.png";